/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { InnerBlocks } from '@wordpress/block-editor';

/**
 * Inner dependencies.
 */
import BaseWrapper from '../../../components/base-wrapper';

export default function save( props ) {
	const { className, attributes } = props;
	const { layout } = attributes;
	const wrapperClasses = classnames(
		className,
		'gutenify-testimonial-item',
		'flex-col-item',
		`gutenify-testimonial-${ layout }`
	);

	return (
		<div className={ wrapperClasses }>
			<BaseWrapper { ...props } name="gutenify/testimonial-item">
				<InnerBlocks.Content />
			</BaseWrapper>
		</div>
	);
}

